var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87157 9.65926V11.6102H15.6264V9.65926H5.87157ZM10.749 0.879883C5.36432 0.879883 0.994141 5.25006 0.994141 10.6347C0.994141 16.0194 5.36432 20.3896 10.749 20.3896C16.1337 20.3896 20.5039 16.0194 20.5039 10.6347C20.5039 5.25006 16.1337 0.879883 10.749 0.879883ZM10.749 18.4386C6.44711 18.4386 2.94511 14.9366 2.94511 10.6347C2.94511 6.33285 6.44711 2.83086 10.749 2.83086C15.0509 2.83086 18.5529 6.33285 18.5529 10.6347C18.5529 14.9366 15.0509 18.4386 10.749 18.4386Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.aae7af6c90326152f3a84457de125fdc.svg";
export { ForwardRef as ReactComponent };